import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoadig: false,
  jobsLength: 0,
  jobs: []
}

export default function jobsReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_JOBS:
      return {...state, loading: action.payload }
    case actions.SAVE_LOADING_JOBS:
      return {...state, saveLoadig: action.payload }
    case actions.GET_JOBS:
      return {...state, jobs: action.payload.jobs, jobsLength: action.payload.jobsLength}
    default:
      return state
  }
}